import { logger } from '@gem/modules/logger';

import Entities from 'STORE';

// Needs Bff implementation
export const setUserPreferences = async (
  categoryIds?: string[],
  locales?: string[]
): Promise<boolean> => {
  const newCategoryIds = categoryIds || Entities.userPreferences.categoryIds;
  const newLocales = locales || Entities.userPreferences.localeIds;

  try {
    Entities.userPreferences.setCategoryIds(newCategoryIds);
    Entities.userPreferences.setLocaleIds(newLocales);

    return true;
  } catch (error) {
    logger.get('API').error('catalog.setUserPreferences', error);
    return false;
  }
};
